import { useAuth } from '@/lib/auth-store';

/** Session-aware auth helpers — avoids guest UI flash before hydrate completes. */
export function useSession() {
  const user = useAuth((s) => s.user);
  const hydrated = useAuth((s) => s.hydrated);
  const sessionStatus = useAuth((s) => s.sessionStatus);
  const sessionError = useAuth((s) => s.sessionError);
  const retry = useAuth((s) => s.retryHydration);

  return {
    user,
    authHydrated: hydrated,
    loggedIn: hydrated && !!user,
    isLoading: !hydrated,
    isDegraded: sessionStatus === 'degraded',
    sessionStatus,
    sessionError,
    retry,
  } as const;
}
